import { render, staticRenderFns } from "./RelatorioPedidoGeralFilho.vue?vue&type=template&id=712a5e3a"
import script from "./RelatorioPedidoGeralFilho.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoGeralFilho.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPedidoGeralFilho.vue?vue&type=style&index=0&id=712a5e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports